import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: r.data }, replace: true });
      })
      .catch((e) => {
        toast.error(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
        navigate("/admin/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-navy" data-testid="auth-callback">
      <p className="text-white/60 text-sm tracking-[0.2em] uppercase font-bold">Signing you in…</p>
    </div>
  );
}
